import api from "./client";

export async function listWorkCenters({ search = null, includeInactive = false } = {}) {
  const data = await listWorkCentersPaged({ search, includeInactive });
  return data.items;
}

export async function listWorkCentersPaged({
  search = null,
  includeInactive = false,
  page,
  limit,
} = {}) {
  const params = new URLSearchParams();
  if (search) params.set("search", String(search));
  if (includeInactive) params.set("include_inactive", "1");
  if (page !== undefined && page !== null) params.set("page", String(page));
  if (limit !== undefined && limit !== null) params.set("limit", String(limit));
  const qs = params.toString() ? `?${params.toString()}` : "";
  const res = await api.get(`/work-centers${qs}`);
  return res.data.data;
}

export async function createWorkCenter(payload) {
  const res = await api.post("/work-centers", payload);
  return res.data.data;
}

export async function updateWorkCenter(id, payload) {
  const res = await api.put(`/work-centers/${id}`, payload);
  return res.data.data;
}

export async function deleteWorkCenter(id) {
  const res = await api.delete(`/work-centers/${id}`);
  return res.data.data;
}

